<template>
  <figure class="bg-icon-download" @click="handleClick(params.data)">
    <i class="material-icons icon-download" title="Descarcar Reporte">
      download
    </i>
  </figure>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  methods: {
    handleClick(params) {
      if (
        params.informepdf === null ||
        params.informepdf === '' ||
        params.informepdf === undefined
      ) {
        this.$snotify.error(
          'Orden ' + params['Número Orden'] + ' sin documento disponible'
        );
      } else {
        window.open(params.informepdf, '_blank');
      }
    },
  },
});
</script>

<style scoped>
.bg-icon-download {
  display: grid;
  place-items: center;
  cursor: pointer;
}
.bg-icon-download .icon-download {
  width: 28px;
  height: 28px;
  color: #27488e;
}
</style>
